import { Controller } from "stimulus"
import { get, destroy } from '@rails/request.js'

export default class extends Controller {
  static targets = ["questionForm", "questionOptionsFormWrapper", "savedButton", "submitButton", "questionOptionsList"]
  static values = {
    id: Number,
  }
  connect() {
    // console.log('connected to question controller')
    // console.log('savedButton', this.savedButtonTarget)
    if (this.hasSavedButtonTarget && this.hasSubmitButtonTarget) {
      setTimeout(() => {
        this.savedButtonTarget.classList.toggle('hidden')
        this.savedButtonTarget.classList.toggle('flex')
        this.submitButtonTarget.classList.toggle('hidden')
      }, 1500)
    }
  }

  cancelForm(e) {
    document.getElementById('question-form-wrapper').remove()
    // const newForm = document.getElementById('form_question')
    // if (newForm) {
    //   newForm.remove()
    //   // this.dispatch('addQuestionButton')
    //   document.getElementById('add-question-button').classList.toggle('hidden')
    // }
  }

  async deleteQuestion(e) {
    const target = e.currentTarget
    const { questionId, deleteFrom } = target.dataset
    const check = await this._checkBeforeDestroy(questionId)
    // console.log('check', check)
    if (confirm(check.msg)) {
      const res = await destroy(`/admin/questions/${questionId}?format=json`)
      const body = await res.json
      if (deleteFrom === 'question') {
        target.parentNode.parentNode.remove()
      } else {
        document.getElementById('question-form-wrapper').remove()
        window.location.reload()
      }
    }
  }

  async _checkBeforeDestroy(questionId) {
    const url = `/admin/questions/${questionId}/check_destroy`
    const res = await get(url)
    return res.json
  }

  selectQuestionType(e) {
    const newValue = e.detail.value;
    const previousValue = e.currentTarget.dataset.currentValue;
    // console.log('previousVal', previousValue)
    // console.log('newValue', newValue)
    if (
      (previousValue == 'single_select' || previousValue == 'multi_select') &&
      (newValue != 'single_select' && newValue != 'multi_select')
    ) {
      // console.log('ONE ----- should remove options')
      this.questionOptionsFormWrapperTarget.classList.add('hidden')
      this.questionOptionsFormWrapperTarget.querySelectorAll('.option-fields').forEach(el => {
        // console.log('el', el)
        if (el.dataset.questionOptionTarget !== 'formTemplate') {
          // console.log('not template, remove')
          el.remove()
        }
      })
      // needs to be removed completely
      e.currentTarget.dataset.currentValue = e.detail.value
      if (this.hasIdValue) {
        destroy(`/admin/questions/${this.idValue}/detach_options?format=json`)
      }

    } else if (
      (newValue == 'single_select' || newValue == 'multi_select') &&
      (previousValue != 'single_select' && previousValue != 'multi_select')
    ) {
      // console.log('TWO ----- should toggle options')
      this.questionOptionsFormWrapperTarget.classList.remove('hidden')
      e.currentTarget.dataset.currentValue = e.detail.value
    } else {
      // console.log('THREE ----- no change')
    }
  }

  async reorderOption(e) {
    // console.log('reorderOption', e.currentTarget)
    const questionOptionId = e.currentTarget.dataset.questionOptionId
    const direction = e.currentTarget.dataset.direction
    const res = await get(`/admin/question_options/${questionOptionId}/reorder_option?direction=${direction}&format=json`)
    const data = await res.json
    if (data.partial) {
      this.questionOptionsListTarget.outerHTML = data.partial
    }
  }
}


